import { http } from '@parapet/common';
import {
  CountryCode,
  CountryCodeApiResponse,
  PhoneWithCountryCodeForm,
} from './models';

export const loadContryCodesFromApi =
  async (): Promise<CountryCodeApiResponse> => {
    const res = await http
      .get<CountryCodeApiResponse>({
        url: 'https://auth.parapetstudios.com/api/Users/Phone/country-codes',
      })
      .asPromise();

    // Sort US and CA to top
    const topCodes = ['US', 'CA'];
    const topOptions = res.countryCodes
      .filter((c) => topCodes.includes(c.abbreviation))
      .reverse();
    const options: CountryCode[] = [
      ...topOptions,
      ...res.countryCodes.filter((c) => !topCodes.includes(c.abbreviation)),
    ];

    return { countryCodes: options, countryPhones: res.countryPhones };
  };

export const loadCodesFromCache = (): CountryCodeApiResponse | null => {
  let codes: CountryCodeApiResponse | null = null;
  try {
    const tempCodes = localStorage.getItem('country-codes');
    if (tempCodes) {
      codes = JSON.parse(tempCodes) as CountryCodeApiResponse;
    }
  } catch (err) {}
  return codes;
};

export const cacheCodes = (res: CountryCodeApiResponse) => {
  try {
    localStorage.setItem('country-codes', JSON.stringify(res));
  } catch (err) {}
};

export const formatUnicodeToHtml = (flagUnicode: string): string =>
  flagUnicode
    .split('\\U')
    .map((s) => parseInt(s, 16))
    .slice(1)
    .join('&#');

export const getPhoneValidityMessage = (
  invalid: boolean,
  form: PhoneWithCountryCodeForm,
): string | null => {
  if (invalid) {
    let message = 'Invalid phone number';
    if (form.countryCode) {
      message = `Invalid ${form.countryCode.abbreviation} phone, format must be ${form.countryCode?.format}`;
    }
    return message;
  }
  return null;
};
